window.addEventListener("turbo:load", () => {
  const selectAllCheckbox = document.querySelector(".select-all-checkbox");
  const checkboxes = document.querySelectorAll(
    '.form-field.checkbox.field input[type="checkbox"]:not(.select-all-checkbox)'
  );
  if (selectAllCheckbox) {
    selectAllCheckbox.addEventListener("change", (event) => {
      checkboxes.forEach((checkbox) => {
        checkbox.checked = event.target.checked;
      });
    });
  }
  const toggleBar = document.querySelector(".toggle-buttons")
  
  if (toggleBar){
    let toBarChart = document.getElementById("bar");
    let toTableChart = document.getElementById("table");
    let tableChart = document.getElementById("table-chart")
    let barChart = document.getElementById("bar-chart")
    
    toBarChart.addEventListener("click", ()=> {
      barChart.style = "display: block";
      tableChart.style = "display: none";
      toBarChart.classList.add("active");
      toTableChart.classList.remove("active");
    })
    toTableChart.addEventListener("click", ()=> {
      tableChart.style = "display: block";
      barChart.style = "display: none";
      toBarChart.classList.remove("active");
      toTableChart.classList.add("active");
    })
  }
});
